// extracted by mini-css-extract-plugin
export default {"Media":"Media-module__Media--XNCZb","AutoPlayVideo":"Media-module__AutoPlayVideo--iLzSY","Video":"Media-module__Video--eR5Ix","Image":"Media-module__Image--ZUvzP"};